import { Reveal } from "./Reveal";

const testimonios = [
  {
    texto:
      "Entré agotada y salí como nueva. El ritual facial y el masaje fueron impecables, y el ambiente en tonos salvia es simplemente hermoso. Mi lugar favorito en Bogotá.",
    nombre: "Valentina Rodríguez",
    detalle: "Ritual Blush",
  },
  {
    texto:
      "Por fin un lugar donde un hombre se siente cómodo cuidándose. La barbería es de otro nivel y el masaje descontracturante me dejó como nuevo. Atención de primera.",
    nombre: "Andrés Gómez",
    detalle: "Ritual del Caballero",
  },
  {
    texto:
      "Fuimos a la experiencia DUO por nuestro aniversario y fue mágico. Estar juntos, relajados y consentidos al mismo tiempo. Volveremos sin duda.",
    nombre: "Camila & Sebastián",
    detalle: "Escape en Pareja",
  },
];

const Testimonials = () => {
  return (
    <section
      id="testimonios"
      data-testid="section-testimonials"
      className="relative bg-[#faf9f6] px-6 py-28 md:px-16 md:py-40"
    >
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <span className="label text-[#593d36]">Testimonios</span>
        </Reveal>
        <Reveal delay={0.05} className="mt-6 max-w-3xl">
          <h2 className="font-serif-display text-3xl sm:text-5xl leading-tight text-[#3a3939]">
            Lo que se siente al vivir{" "}
            <span className="italic text-[#593d36]">DUO</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {testimonios.map((t, i) => (
            <Reveal
              key={t.nombre}
              delay={i * 0.12}
              y={50}
              className={`rounded-3xl border border-[#3a3939]/10 bg-white/60 p-8 backdrop-blur-sm ${
                i === 1 ? "md:mt-10" : ""
              }`}
            >
              <span className="font-serif-display text-5xl leading-none text-[#cea498]">
                “
              </span>
              <p className="mt-2 font-cormorant text-xl leading-relaxed text-[#4a423e]">
                {t.texto}
              </p>
              <div className="mt-8 border-t border-[#3a3939]/10 pt-5">
                <p className="font-serif-display text-lg text-[#3a3939]">
                  {t.nombre}
                </p>
                <span className="label text-[#593d36]">{t.detalle}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
